
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetohyderabadcab() {



    const cardData =
    {
        keyword: ' Pune to Hyderabad Cab',
        heading: 'Prince Cabs: Pune to Hyderabad Cab',
        headingDescription: 'Prince Cabs provides trusted Pune to Hyderabad Cab services, ideal for business travel, family trips, student journeys, and long-distance tours. Our fleet of well-maintained sedans, SUVs, and luxury cars ensures a safe, smooth, and comfortable ride on the Pune–Hyderabad route. With professional chauffeurs, transparent pricing, and on-time pickups, we make your interstate travel convenient and stress-free. Choose Prince Cabs’ dedicated Pune to Hyderabad cab service for affordability, reliability, and complete comfort.',

        top: 'Top Places to Visit in Hyderabad with Prince Cabs',

"topPlaces": [
  {
    "title": "Charminar",
    "description": "Charminar, built in 1591 by Sultan Muhammad Quli Qutb Shah, is the iconic landmark of Hyderabad. The four grand minarets and Indo-Islamic architecture symbolize the city’s rich heritage. The surrounding Laad Bazaar is famous for bangles and pearls. The monument is beautifully illuminated at night. It remains the most photographed spot in Hyderabad. Charminar is the heartbeat of the Old City."
  },
  {
    "title": "Golconda Fort",
    "description": "Golconda Fort, built in the 16th century, was once the capital of the Qutb Shahi dynasty. Famous for its acoustics, palaces, and engineering marvels, the fort showcases grandeur. The evening light-and-sound show narrates its history with drama. Visitors enjoy panoramic views of Hyderabad from the fort’s summit. It is also known as the birthplace of the world-famous Kohinoor diamond. Golconda Fort blends history, architecture, and legend."
  },
  {
    "title": "Hussain Sagar Lake",
    "description": "Hussain Sagar Lake, built in 1563, connects Hyderabad and Secunderabad. At its center stands a massive monolithic statue of Lord Buddha. Boat rides to the statue are a popular activity. The lakefront features parks, eateries, and Tank Bund promenade. Evening lights make the area vibrant and romantic. Hussain Sagar is a favorite leisure spot for locals and tourists."
  },
  {
    "title": "Ramoji Film City",
    "description": "Ramoji Film City, spread over 2,000 acres, is the world’s largest integrated film studio complex. Visitors explore film sets, theme parks, gardens, and adventure zones. Daily shows, rides, and cultural performances entertain families. Guided tours take guests behind the scenes of filmmaking. It is also a favorite destination for weddings and corporate events. Ramoji Film City is Hyderabad’s entertainment paradise."
  },
  {
    "title": "Salar Jung Museum",
    "description": "Salar Jung Museum is one of India’s largest art museums, housing over 40,000 artifacts. Its collection includes paintings, sculptures, textiles, weapons, and manuscripts from around the world. Highlights include the Veiled Rebecca and the Musical Clock. The museum reflects the eclectic taste of Nawab Mir Yousuf Ali Khan, Salar Jung III. History and art lovers find it mesmerizing. It is a treasure trove of global heritage in Hyderabad."
  },
  {
    "title": "Birla Mandir",
    "description": "Birla Mandir, built entirely of white marble, is a serene temple dedicated to Lord Venkateswara. Located atop a 280-foot hill, it offers panoramic views of Hyderabad and Hussain Sagar Lake. The temple’s carvings depict scenes from Hindu epics. Visitors experience peace and spirituality in its tranquil setting. Photography is restricted, adding to its sanctity. Birla Mandir is both a spiritual and architectural delight."
  },
  {
    "title": "Chowmahalla Palace",
    "description": "Chowmahalla Palace was the official residence of the Nizams of Hyderabad. Built in the 18th century, it showcases Mughal, Persian, and European influences. The palace complex includes grand halls, fountains, and courtyards. Its chandeliers and artifacts narrate stories of regal opulence. The palace hosts cultural events and exhibitions. It is a majestic glimpse into Hyderabad’s royal past."
  },
  {
    "title": "Mecca Masjid",
    "description": "Mecca Masjid, built in the 17th century, is one of India’s largest mosques. Its name comes from bricks made of soil brought from Mecca. The mosque’s architecture features arches, domes, and intricately carved granite. It can accommodate over 10,000 worshippers. Located near Charminar, it forms part of Hyderabad’s heritage circuit. Mecca Masjid is a sacred and architectural marvel."
  },
  {
    "title": "Lumbini Park",
    "description": "Lumbini Park is a lakeside garden near Hussain Sagar, popular for its musical fountain and laser shows. Families enjoy evening boat rides and the serene greenery. The park is well-maintained with walking paths and children’s play areas. Night laser shows narrating Hyderabad’s history are a highlight. It offers a refreshing retreat in the city center. Lumbini Park blends leisure and culture."
  },
  {
    "title": "Nehru Zoological Park",
    "description": "Nehru Zoological Park is one of India’s largest zoos, spread over 380 acres. It houses lions, tigers, elephants, rhinos, and exotic birds. Safari rides offer close encounters with wildlife. The zoo also features aquariums, butterfly parks, and reptile houses. Families and children find it educational and fun. It is a green escape within Hyderabad."
  },
  {
    "title": "Qutb Shahi Tombs",
    "description": "The Qutb Shahi Tombs complex houses the mausoleums of the Qutb Shahi rulers. Built with domes, minarets, and intricate stucco work, the tombs reflect Indo-Islamic architecture. The landscaped gardens add beauty to the site. Restoration work has revived their historic charm. Cultural events and festivals are often held here. The tombs represent Hyderabad’s royal heritage."
  },
  {
    "title": "Jalavihar Water Park",
    "description": "Jalavihar Water Park, located near Hussain Sagar Lake, is a family-friendly attraction. It offers water slides, wave pools, and kids’ play zones. The park is well-maintained with food courts and entertainment areas. It is a perfect summer getaway for locals and tourists. The proximity to the lakefront adds scenic value. Jalavihar is Hyderabad’s fun-filled recreation spot."
  },
  {
    "title": "Snow World",
    "description": "Snow World is India’s first indoor snow theme park, located near Hussain Sagar Lake. It recreates icy conditions with snow slides, skating, and igloos. Visitors experience sub-zero temperatures in a tropical city. Jackets and boots are provided for comfort. It is popular among children and families. Snow World offers a unique chill in Hyderabad’s warm climate."
  },
  {
    "title": "Shilparamam",
    "description": "Shilparamam is an arts and crafts village located in Hi-Tech City. It showcases traditional Indian handicrafts, handlooms, and cultural performances. Festivals and fairs bring artisans from across India. Visitors shop for souvenirs, textiles, and decor. The village also hosts dance, music, and folk theater shows. Shilparamam is Hyderabad’s cultural hub blending tradition with modernity."
  },
  {
    "title": "Osman Sagar (Gandipet Lake)",
    "description": "Osman Sagar, also called Gandipet Lake, is a man-made reservoir on the outskirts of Hyderabad. It was built during the reign of the last Nizam. The lake is surrounded by gardens, resorts, and picnic spots. Sunsets here are mesmerizing with calm waters. It is a popular weekend getaway for families and couples. Osman Sagar offers peace and natural beauty away from the city."
  }
],

   "services": [
    {
      "name": "Pune to Hyderabad Cab Charges",
      "description": "Get transparent and competitive cab charges for your Pune to Hyderabad journey. Choose from a range of vehicles like Innova Crysta, Swift Dzire, and Etios with affordable pricing tailored to your travel needs."
    },
    {
      "name": "Pune to Hyderabad Cab Service",
      "description": "Reliable and comfortable cab service from Pune to Hyderabad with experienced drivers and well-maintained cars. Whether it’s a one-way trip or a round trip, travel hassle-free with our dedicated taxi service."
    },
    {
      "name": "Pune to Hyderabad Innova Crysta",
      "description": "Travel in luxury and spacious comfort with our Pune to Hyderabad Innova Crysta cab service. Ideal for families or groups, our Innova Crysta ensures a smooth and premium experience on long-distance trips."
    },
    {
      "name": "Pune to Hyderabad Etios Car Rental",
      "description": "Affordable and efficient Etios car rental for your Pune to Hyderabad trip. Perfect for small groups and solo travelers seeking comfort with budget-friendly options."
    },
    {
      "name": "Pune to Hyderabad Swift Dzire Rental",
      "description": "Swift Dzire rental service from Pune to Hyderabad offering comfortable rides with economical pricing. Ideal for business travelers and small families."
    },
    {
      "name": "Swift Dzire on Rent in Pune",
      "description": "Rent a Swift Dzire in Pune for outstation trips including Hyderabad, with flexible rental packages, reliable vehicles, and professional drivers ensuring a smooth journey."
    },
    {
      "name": "Pune to Hyderabad Dzire Cab",
      "description": "Book Dzire cab from Pune to Hyderabad for affordable and comfortable travel. Perfect for solo travelers and small families who want a balance of comfort and cost."
    },
    {
      "name": "Pune to Hyderabad Affordable Taxi",
      "description": "Choose from a wide range of affordable taxi options for your Pune to Hyderabad trip without compromising on quality, safety, or punctuality."
    },
    {
      "name": "Pune to Hyderabad Luxury Cab",
      "description": "Experience luxury cab service from Pune to Hyderabad with premium vehicles like Innova Crysta and Swift Dzire, offering plush interiors and impeccable service."
    },
    {
      "name": "Pune to Hyderabad Round Trip Taxi",
      "description": "Convenient round trip taxi service from Pune to Hyderabad with flexible scheduling and comfortable vehicles, perfect for business trips, family visits, or tourism."
    },
    {
      "name": "Pune to Hyderabad Family Cab",
      "description": "Family-friendly cab services from Pune to Hyderabad featuring spacious and safe vehicles like Innova Crysta and Dzire, ensuring a comfortable journey for your loved ones."
    }
  ],
  "tableData": [
    ["Pune to Hyderabad Cab Charges", "Pune to Hyderabad Cab Service"],
    ["Pune to Hyderabad Innova Crysta", "Pune to Hyderabad Etios Car Rental"],
    ["Pune to Hyderabad Swift Dzire Rental", "Swift Dzire on Rent in Pune"],
    ["Pune to Hyderabad Dzire Cab", "Pune to Hyderabad Affordable Taxi"],
    ["Pune to Hyderabad Luxury Cab", "Pune to Hyderabad Round Trip Taxi"],
    ["Pune to Hyderabad Family Cab"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Pune to Hyderabad Cab Service",
        "WhyChoosedescription": "Prince Cabs offers trustworthy and comfortable cab services from Pune to Hyderabad, catering to business professionals, tourists, and families. Covering around 560 kilometers, our service ensures a safe, smooth, and stress-free journey, allowing you to focus on your plans while we manage the travel logistics."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
        "WhyChoosedescription": "Our fleet consists of well-maintained sedans and SUVs such as Swift Dzire and Innova, designed for long-distance travel comfort. Spacious seating, ample legroom, sufficient luggage space, and effective air conditioning ensure you enjoy a relaxed journey throughout the trip."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Route Expertise",
        "WhyChoosedescription": "Our professional drivers are skilled in navigating the highways and routes between Pune and Hyderabad. They prioritize safe driving, timely breaks, and efficient route planning to ensure you arrive at your destination refreshed and on time."
    },
    {
        "WhyChooseheading": "Flexible Booking Options Tailored to Your Travel Needs",
        "WhyChoosedescription": "Prince Cabs offers customizable rental packages including one-way trips, round trips with waiting time, and multi-day rentals. Booking is convenient through phone, WhatsApp, or online with instant confirmation and flexible cancellation policies."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "Our Pune to Hyderabad cab service offers clear and competitive pricing that includes fuel, tolls, driver allowances, and taxes. We accept multiple secure payment options including UPI, credit/debit cards, net banking, and cash for your convenience."
    },
    {
        "WhyChooseheading": "Sanitized and Well-Maintained Fleet for Your Safety",
        "WhyChoosedescription": "Each vehicle undergoes thorough cleaning and sanitization before every trip to ensure a hygienic environment. Regular maintenance checks guarantee mechanical reliability, while essential safety features like seat belts and airbags provide added protection."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for a Hassle-Free Experience",
        "WhyChoosedescription": "Our dedicated customer support team is available round the clock to assist with bookings, itinerary changes, or any travel-related queries, ensuring a smooth and worry-free Pune to Hyderabad cab journey."
    }
]































    }

const faqData = [
    {
        question: 'Does Prince Cabs provide cab services from Pune to Hyderabad?',
        answer: 'Yes, Prince Cabs offers reliable and comfortable cab services for travel from Pune to Hyderabad, suitable for business trips, family visits, and leisure travel.',
    },
    {
        question: 'What types of vehicles are available for Pune to Hyderabad trips?',
        answer: 'We provide a variety of vehicles including Swift Dzire, Innova, and Tempo Traveller to accommodate solo travelers, families, and groups.',
    },
    {
        question: 'How long does the journey from Pune to Hyderabad take by cab?',
        answer: 'The journey usually takes around 10 to 12 hours depending on traffic and road conditions.',
    },
    {
        question: 'Can I book a round-trip cab from Pune to Hyderabad?',
        answer: 'Yes, Prince Cabs offers flexible one-way and round-trip packages tailored to your travel needs.',
    },
    {
        question: 'Are the cabs sanitized and well-maintained for long-distance travel?',
        answer: 'Absolutely! All vehicles are regularly cleaned, sanitized, and serviced to ensure your safety and comfort during the trip.',
    },
    {
        question: 'What are the approximate fares for Pune to Hyderabad cab service?',
        answer: 'Fares depend on vehicle type, distance, and duration. Contact Prince Cabs for a personalized and competitive quote.',
    },
    {
        question: 'How do I book a cab from Pune to Hyderabad?',
        answer: 'Booking is easy via our website or by calling our customer support team with your travel details for quick confirmation.',
    },
];

const testimonials = [
    {
        name: "Mr. Amit Reddy",
        position: "Business Traveler",
        text: "Prince Cabs provided excellent service from Pune to Hyderabad. The cab was comfortable and the driver professional.",
        image: "/img/testimonial/testimonial-thumb-hyderabad-1.png",
    },
    {
        name: "Ms. Sneha Iyer",
        position: "Family Traveler",
        text: "Our Pune to Hyderabad trip with Prince Cabs was smooth and hassle-free. Highly recommend their services.",
        image: "/img/testimonial/testimonial-thumb-hyderabad-2.png",
    },
];



































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Pune to Hyderabad Cab",
  "description": "Affordable and reliable cab services from Pune to Hyderabad including Innova Crysta, Etios, Swift Dzire, and luxury family cabs. Round trip and rental options available.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "addressCountry": "IN"
    }
  },
  "serviceType": [
    "Pune to Hyderabad Cab Charges",
    "Pune to Hyderabad Cab Service",
    "Pune to Hyderabad Innova Crysta",
    "Pune to Hyderabad Etios Car Rental",
    "Pune to Hyderabad Swift Dzire Rental",
    "Swift Dzire on Rent in Pune",
    "Pune to Hyderabad Dzire Cab",
    "Pune to Hyderabad Affordable Taxi",
    "Pune to Hyderabad Luxury Cab",
    "Pune to Hyderabad Round Trip Taxi",
    "Pune to Hyderabad Family Cab"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  }
};





    return (
        <div>

<Helmet>
  <title>Pune to Hyderabad Cab | Innova, Dzire, Etios Taxi Service</title>
  <meta
    name="description"
    content="Affordable and reliable cab services from Pune to Hyderabad including Innova Crysta, Etios, Swift Dzire, luxury family cabs, and round trip options."
  />
  <meta
    name="keywords"
    content="Pune to Hyderabad Cab Charges, Pune to Hyderabad Cab Service, Pune to Hyderabad Innova Crysta, Pune to Hyderabad Etios Car Rental, Pune to Hyderabad Swift Dzire Rental, Swift Dzire on Rent in Pune, Pune to Hyderabad Dzire Cab, Pune to Hyderabad Affordable Taxi, Pune to Hyderabad Luxury Cab, Pune to Hyderabad Round Trip Taxi, Pune to Hyderabad Family Cab"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/53.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetohyderabadcab ;